<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "MainPage",
  data() {
    return {
      title: "home page",
    };
  },

};
</script>
